import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

// Typing cursor blink animation
const blink = keyframes`
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
`;

// Scale up animation for the text
const scaleUp = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;





// Loading screen container
const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transition: opacity 0.8s ease-in-out, visibility 0.8s ease-in-out;

`;

// Main text container
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${scaleUp} 0.8s ease-out;
`;

// Main text styling
const LoadingText = styled.h1`
  font-size: 6rem;
  font-weight: 900;
  color: #E53E3E;
  text-align: center;
  letter-spacing: 0.05em;
  font-family: 'Impact', 'Arial Black', 'Franklin Gothic Bold', 'Arial', sans-serif;
  text-transform: uppercase;
  margin: 0;
  font-stretch: condensed;
  line-height: 0.9;
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 3.5rem;
    letter-spacing: 0.03em;
  }

  @media (max-width: 480px) {
    font-size: 2.5rem;
    letter-spacing: 0.02em;
  }
`;

// Typing cursor
const Cursor = styled.span`
  color: #E53E3E;
  animation: ${blink} 1s infinite;
  font-weight: 900;
`;



const LoadingScreen = ({ isVisible }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const fullText = 'URVANSH SHAH';
  const typingSpeed = 100; // milliseconds per character

  useEffect(() => {
    if (!isVisible) return;

    // Typing animation
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setDisplayedText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        // Hide cursor after typing is complete
        setTimeout(() => {
          setShowCursor(false);
        }, 500);
      }
    }, typingSpeed);

    return () => {
      clearInterval(typingInterval);
    };
  }, [isVisible]);

  return (
    <LoadingContainer isVisible={isVisible}>
      <TextContainer>
        <LoadingText>
          {displayedText}
          {showCursor && <Cursor>|</Cursor>}
        </LoadingText>
      </TextContainer>
    </LoadingContainer>
  );
};

export default LoadingScreen;
